import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {EiDashboardPage} from "../page/overview/ei-dashboard/ei-dashboard.page";
import {
    EiImportAnalyticsComponent
} from "../component/protected-components/ei-import-analytics-component/ei-import-analytics.component";
import {
    EiImportObjectComponent
} from "../component/protected-components/ei-import-object-component/ei-import-object.component";
import {
    EiImportObjectWrapperComponent
} from "../component/protected-components/ei-import-object-component-wrapper/ei-import-object-wrapper.component";
import {
    EiImportObjectSummaryComponent
} from "../component/protected-components/ei-import-object-summary/ei-import-object-summary.component";
import {
    EiImportRecordNotFoundComponent
} from "../component/protected-components/ei-import-record-not-found/ei-import-record-not-found.component";
import {
    EiImportRecordObjectComponent
} from "../component/protected-components/ei-import-record-object-component/ei-import-record-object.component";
import {
    EiImportRecordObjectWrapperComponent
} from "../component/protected-components/ei-import-record-object-component-wrapper/ei-import-record-object-wrapper.component";
import {
    EiImportRecordStructureObjectComponent
} from "../component/protected-components/ei-import-record-structure-object-component/ei-import-record-structure-object.component";
import {
    EiImportTableWidgetComponent
} from "../component/protected-components/ei-import-table-widget-component/ei-import-table-widget.component";
import {EiConfigPage} from "../page/overview/ei-config/ei-config.page";
import {WorkbenchLandingComponent} from "../page/workbench/components/workbench-landing/workbench-landing.component";
import {WorkbenchMappingComponent} from "../page/workbench/components/workbench-mapping/workbench-mapping.component";
import {WorkbenchPage} from "../page/workbench/workbench-page.component";


const eiModuleEntry: TestModuleDefinition = {
    key: 'ei',
    label: 'Entity Import (ei)',
    components: [
        {
            key: 'EiImportAnalyticsComponent',
            component: EiImportAnalyticsComponent,
            selector: 'ei-import-analytics-component',
            type: 'Component',
            label: 'ei import analytics component'
        },
        {
            key: 'EiImportObjectComponent',
            component: EiImportObjectComponent,
            selector: 'ei-import-object-component',
            type: 'ObjectBaseComponent',
            label: 'ei import object component'
        },
        {
            key: 'EiImportObjectWrapperComponent',
            component: EiImportObjectWrapperComponent,
            selector: 'ei-import-object-component-wrapper',
            type: 'Component',
            label: 'ei import object wrapper component'
        },
        {
            key: 'EiImportObjectSummaryComponent',
            component: EiImportObjectSummaryComponent,
            selector: 'ei-import-object-summary',
            type: 'Component',
            label: 'ei import object summary component'
        },
        {
            key: 'EiImportRecordNotFoundComponent',
            component: EiImportRecordNotFoundComponent,
            selector: 'ei-import-record-not-found',
            type: 'Component',
            label: 'ei import record not found component'
        },
        {
            key: 'EiImportRecordObjectComponent',
            component: EiImportRecordObjectComponent,
            selector: 'ei-import-record-object-component',
            type: 'ObjectBaseComponent',
            label: 'ei import record object component'
        },
        {
            key: 'EiImportRecordObjectWrapperComponent',
            component: EiImportRecordObjectWrapperComponent,
            selector: 'ei-import-record-object-component-wrapper',
            type: 'Component',
            label: 'ei import record object wrapper component'
        },
        {
            key: 'EiImportRecordStructureObjectComponent',
            component: EiImportRecordStructureObjectComponent,
            selector: 'ei-import-record-structure-object-component',
            type: 'ObjectBaseComponent',
            label: 'ei import record structure object component'
        },
        {
            key: 'EiImportTableWidgetComponent',
            component: EiImportTableWidgetComponent,
            selector: 'ei-import-table-widget-component',
            type: 'Component',
            label: 'ei import table widget component'
        },
        {
            key: 'EiDashboardPage',
            component: EiDashboardPage,
            selector: 'ei-import-dashboard-page',
            type: 'PageComponent',
            label: 'ei dashboard page'
        },
        {
            key: 'EiConfigPage',
            component: EiConfigPage,
            selector: 'mvs-ei-config',
            type: 'PageComponent',
            label: 'ei config page'
        },
        {
            key: 'WorkbenchLandingComponent',
            component: WorkbenchLandingComponent,
            selector: 'workbench-landing',
            type: 'Component',
            label: 'workbench landing component'
        },
        {
            key: 'WorkbenchMappingComponent',
            component: WorkbenchMappingComponent,
            selector: 'workbench-mapping',
            type: 'Component',
            label: 'workbench mapping component'
        },
        {
            key: 'WorkbenchPage',
            component: WorkbenchPage,
            selector: 'workbench-page',
            type: 'PageComponent',
            label: 'workbench page'
        }
    ]
}

export const EI_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: eiModuleEntry, multi: true}
];